import React from 'react';
import server from '../../server';
import {LockedModal, NotAvailableModal} from './Modals';

function hour_to_Min(hour){
    let split = hour.split(":");
    return parseInt(split[0]) * 60 + parseInt(split[1]);
}

function min_to_Hour(minutes){
    let hourText = Math.floor(minutes / 60);
    let minutesText = (minutes % 60);

    if (hourText < 10)
        hourText = "0" + hourText;

    if (minutesText < 10)
        minutesText = "0" + minutesText;

    return hourText + ":" + minutesText;
}

function get_actual_day(day){
    if(day == 0) return 7;
    return day;
}

class HourBox extends React.Component{
    state = {
        selected:false
    }

    click = () =>{

        if(this.state.selected == false){
            this.props.createDate(this.props.clinic);

            if(window.innerWidth < 1024) this.props.openSide();
        }else{
            this.props.deleteDate();
        }

        this.setState({selected: !this.state.selected});
    }

    render(){
        const disabledStyle = {color: "#9E9E9E", backgroundColor: "#ECEFF1", borderColor: "lightgray", cursor: "none"};
        const selectedStyle = {backgroundColor: "#3076af", color:"#fff"};
        const unselectedStyle = {backgroundColor: "transparent", color:"#3583c3"};
        let afterText = "";

        if(this.props.disabled && this.props.patient != null){
            afterText = " - " + this.props.patient.name.substr(0,11) + "..." + " - " + (this.props.patient.clinic == true ? "C" : "D");
        }else if(this.props.disabled == false){
            afterText = " - " + (this.props.clinic ? "C" : "D");
        }

        let clickAction = this.props.disabled ? (this.props.patient != null ? this.props.unavaible : this.props.displayLocked) : null;

        return(
            <div onClick={clickAction} 
                style={this.props.disabled == true ? disabledStyle : (this.props.selected === true ? selectedStyle : unselectedStyle)} 
                class="schedule-button w-100p open-modal">
                <label>
                    <input id={this.props.clinic + this.props.time + "box"} onClick={() => this.click()} selected={this.state.selected} disabled={this.props.disabled} type="checkbox"/>
                    <span>{this.props.time + afterText}</span>
                </label>
            </div>
        )
    }
}

export class Calendar extends React.Component{
    state = {
        startDate: new Date(),
        open: false,
        lockedModal: false,
        book:{},
        availableHours:[],
        lockHours:{},
        colNum: 0
    }

    refresh = () =>{
        let dates = this.loadDates();
        let that = this;
        
        this.loadDateLabel(dates);

        this.setState({colNum: dates.length}, () => 
            dates.forEach((key,i) => {
                that.setState({["col-" + i]: []},() => that.loadLocks(key,i));
            }));
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.dates != this.props.dates) this.refresh();
    }

    loadDates = () =>{
        const milli = 60 * 60 * 24 * 1000;
        let current = this.state.startDate;
        let dates = [];
        
        let count = window.innerWidth < 1240 ? 3 : 6;

        for(let i = 0; i < count; i++){
            let newDate = new Date(current.getTime() + (milli * i))

            let day = newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();
            let month = newDate.getMonth() + 1 < 10 ? "0" + (newDate.getMonth() + 1) : newDate.getMonth() + 1;

            dates.push({string:day + "/" + month,stringDate: day, stringMonth:month, day:get_actual_day(newDate.getDay()), date: newDate});
        }

        return dates;
    }

    loadLocks = (date, i) =>{
        let fisioterapistId = server.user.id;
        let that = this;
        let today = new Date();
        server.get("fisioterapists/" + fisioterapistId + "/timelocks/" + today.getFullYear()  + "-" + date.stringDate + "-" + date.stringMonth,
        (data) =>{
            that.state.lockHours[date.stringDate + "-" + date.stringMonth] = data.locks; 
            that.loadHourBoxes(date,i)});
    }

    loadDateLabel = (dates) =>{
        let labels=["Seg","Ter","Qua","Qui","Sex","Sab","Dom"];
        let html = dates.slice().map((date) => 
        <div key={date.string} class="w-100p ta-c pX-20 schedule-grid-min-w">
            <p style={{margin:0}}>{labels[date.day - 1]}</p>
            <b>{date.string}</b>
        </div>);
       
        this.setState({html:html});
    }

    createDate = (name, date, isClinic) =>{
        let obj = this.props.selectedDates;
        obj[name] = {date:date, isClinic:isClinic};
        this.props.updateState({target:{id:"selectedDates",value:obj}})
    }

    deleteDate = (name) =>{
        let obj = this.props.selectedDates;
        delete obj[name];
        this.props.updateState({target:{id:"selectedDates",value:obj}})
    }

    checkAvailability = (date,hour) =>{
        let minutes = hour_to_Min(hour);
        let available = true;
        let book = null;

        Object.keys(this.props.bookedHours).forEach((booked) =>{
            let bookMinutes = hour_to_Min(booked.split(" ")[1]);
            if(date.split(" ")[0] == booked.split(" ")[0])
                if((minutes >= bookMinutes && minutes <= bookMinutes + server.user.clinicAppointmentLength) || 
                   (!booked.clinic && minutes >= bookMinutes - 30 && minutes <= bookMinutes + 30)){
                    available =  false;
                    book = booked;
                }
        })
        return {available:available,book:book};
    }

    checkLocked = (date, hour) =>{
        let dateSplit = date.split(" ")[0].split("-");
        let lockedDates = this.state.lockHours[dateSplit[2] + "-" + dateSplit[1]]
        let minutes = hour_to_Min(hour)

        let locked = null;

        lockedDates.forEach(lockedDate =>{
            if(lockedDate.hour == minutes){
                locked = lockedDate;
                return;
            }
        });
        
        return locked;
    }

    loadHourBoxes = (date, i) =>{
        let hourBoxes = [];
        let day = date.day;
        let dateObj = date.date;

        let dd = dateObj.getDate();
        let mm = dateObj.getMonth()+1;
        let yyyy = dateObj.getFullYear();

        for(let i = 360; i < 1441; i+=30){
            let clinicDates = this.props.dates[1 + "-" + parseInt(day)] ? this.props.dates[1 + "-" + parseInt(day)] : [];
            let homeDates = this.props.dates[0 + "-" + parseInt(day)] ? this.props.dates[0 + "-" + parseInt(day)] : [];
            if(true){
                const hour = min_to_Hour(i);
                const index = clinicDates.indexOf(hour) != -1 ? 1 : homeDates.indexOf(hour) != -1 ? 0 : -1;
                if(index == -1){
                    hourBoxes.push(<HourBox 
                        disabled={true} 
                        key={date.day + hour} 
                        time={hour}/>);
                }else{
                    let serverDate = yyyy + "-" + (parseInt(mm) < 10 ? "0" + mm : mm) + "-" + (parseInt(dd) < 10 ? "0" + dd : dd) + " " + hour;
                    let availability = this.checkAvailability(serverDate,hour)
                    let locked = this.checkLocked(serverDate,hour);
                    let disabled = !availability.available || locked != null;

                    hourBoxes.push(<HourBox
                                    clinic={index == 1}
                                    locked={locked}
                                    selected = {Object.keys(this.props.selectedDates).indexOf(dd + mm + yyyy + "|" + day.toString() + hour.toString()) != -1}
                                    displayLocked={()=>this.setState({lockedModal: true, currentLocked: locked})}
                                    unavaible={()=>this.setState({open:true,book:this.props.bookedHours[availability.book]})}
                                    patient={this.props.bookedHours[availability.book]} 
                                    openSide={this.props.openSide}
                                    createDate={(clinic) => this.createDate(dd + mm + yyyy + "|" + day.toString() + hour.toString(), serverDate, clinic)} 
                                    deleteDate={() => this.deleteDate(dd + mm + yyyy + "|" + day.toString() + hour.toString())} 
                                    disabled={disabled} 
                                    key={day.toString() + hour} 
                                    time={hour}/>);
                }
            }
        }

        this.setState({["col-"+i]: hourBoxes});
    }

    changeDate = (i) =>{
        const count = window.innerWidth < 1240 ? 3 : 6;
        const day = 60 * 60 * 24 * 1000;
        const date = new Date(this.state.startDate.getTime() + (day * i * count))
        console.log(date)
        this.setState({startDate: date, availableHours:[]},() =>{
            this.refresh();
        });
    }

    unlock = () =>{
        let that = this;
        fetch(server.address + "/fisioterapists/timelocks/" + this.state.currentLocked.id, {
            method:"DELETE"
        }).then((response) =>{
            that.setState({lockedModal:false});
            that.refresh();
        });
    }

    mergeColumns = () =>{
        let html = [];

        for(let i = 0; i < this.state.colNum; i++){
            let currentCol = []
            if(this.state["col-"+i]) this.state["col-"+i].forEach((hourbox) => currentCol.push(hourbox));

            html.push(<div key={"col-" + i} className="w-100p ta-c pX-20 schedule-column schedule-grid-min-w">
                {currentCol}
            </div>)
        }

        return html;
    }

    render(){
        console.log(this.state.book)
        return(
            <div>
                <div style={{height:60}} class="table-header peers pY-20 jc-sb ai-c">
                    <div class="peers w-100p pos-a jc-sb">
                        <button onClick={() => this.changeDate(-1)} class="btn btn-clear peers ai-c pX-5 pY-0 bdrs-2 mR-3 cur-p c-client-default fsz-md" type="button">
                            <i class="fa fa-chevron-circle-left fsz-xl"></i>
                        </button>
                        <button onClick={() => this.changeDate(1)} class="btn btn-clear peers ai-c pX-5 pY-0 bdrs-2 mR-3 cur-p c-client-default fsz-md" type="button">
                            <i class="fa fa-chevron-circle-right fsz-xl"></i>
                        </button>
                    </div>
                    {this.state.html}
                </div>
                <div class="scrollable h-100p">
                    <div class="ai-c">
                        <div class="table-body peers jc-sb ai-s">
                            {this.mergeColumns()}
                        </div>

                    </div>
                </div>
                <LockedModal unlock={this.unlock} locked={this.state.currentLocked} close={() => this.setState({lockedModal:false})} open={this.state.lockedModal}/>
                <NotAvailableModal book={this.state.book} close={() => this.setState({open:false})} open={this.state.open}/>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/schedule/Calendar.js